import { Elm } from "../src/Main.elm"
import logoUrl from "../../common/web/logo_web.png"
import googleButtonNormalUrl from "../../common/web/assets/btn_google_light_normal_ios.svg"
import googleClassroomSquareLogoUrl from "../../common/web/assets/classroom_square_logo_32x32_yellow_stroke_icon@2x.png"
import "bulma"
import "@mdi/font/scss/materialdesignicons.scss"
import videojs from "video.js"

// 1a. init Firebase
const googleApiKey = "AIzaSyBeJVwOoEQFMVQgpgERbxvb2WzxpjvV_Vk"
const firebaseConfig = {
  apiKey: googleApiKey,
  authDomain: "unrulr.firebaseapp.com",
  databaseURL: "https://unrulr.firebaseio.com",
  projectId: "unrulr",
  storageBucket: "unrulr.appspot.com",
  messagingSenderId: "77266829364",
  appId: "1:77266829364:web:7068cccd3e246adeae0a61",
  measurementId: "G-3WCDNC2SX5"
}

firebase.initializeApp(firebaseConfig)
firebase.analytics()

// 1b. init Google
const googleFirebaseWebClientId =
  "77266829364-sms836i681tqlq2jq5bqggqfiodn0in9.apps.googleusercontent.com"
gapi.load("auth2", () => {
  gapi.auth2.init({ client_id: googleFirebaseWebClientId }).then(
    authInstance => {
      onSignIn(authInstance.currentUser.get())
    },
    err => {
      console.error("error initializing gapi.auth2", err)
    }
  )
})

const isUserEqual = (googleUser, firebaseUser) => {
  if (firebaseUser) {
    var providerData = firebaseUser.providerData
    for (var i = 0; i < providerData.length; i++) {
      if (
        providerData[i].providerId ===
          firebase.auth.GoogleAuthProvider.PROVIDER_ID &&
        googleUser.getBasicProfile() &&
        providerData[i].uid === googleUser.getBasicProfile().getId()
      ) {
        // We don't need to reauth the Firebase connection.
        return true
      }
    }
  }
  return false
}

// 2. init Elm
const flags = {
  logoUrl,
  googleButtonNormalUrl,
  googleClassroomSquareLogoUrl,
  googleApiKey
}

const app = Elm.Main.init({
  node: document.getElementById("elm"),
  flags
})

// === PORTS === //

// 1. logging

app.ports.logError.subscribe(msg => {
  console.error(msg)
})

app.ports.logInfo.subscribe(msg => {
  console.log(msg)
})

// 2. firebase port integration

const authorizeFirebaseUser = user => {
  //console.log("FIREBASE get id_token", user)
  user.getIdToken(/* forceRefresh */ true).then(
    idToken => {
      //console.log("UNRULR signing in...")
      app.ports.setIdToken.send(idToken)
    },
    error => {
      console.error("FIREBASE error", error)
      //console.log("UNRULR signing out...")
      app.ports.setIdToken.send(null)
    }
  )
}

const onSignIn = googleUser => {
  const authResponse = googleUser.getAuthResponse(true)
  //console.log("GOOGLE sign-in", authResponse)
  if (!authResponse) {
    //console.log("UNRULR signing out...")
    app.ports.setIdToken.send(null)
    return
  }

  app.ports.setGoogleAuthResponse.send(authResponse)
  // We need to register an Observer on Firebase Auth to make sure auth is initialized.
  const unsubscribe = firebase.auth().onAuthStateChanged(firebaseUser => {
    unsubscribe()
    // Check if we are already signed-in Firebase with the correct user.
    if (!isUserEqual(googleUser, firebaseUser)) {
      // Build Firebase credential with the Google ID token.
      const credential = firebase.auth.GoogleAuthProvider.credential(
        googleUser.getAuthResponse().id_token
      )
      // Sign in with credential from the Google user.
      firebase
        .auth()
        .signInAndRetrieveDataWithCredential(credential)
        .then(result => {
          //console.log("FIREBASE sign-in", result)
          authorizeFirebaseUser(result.user)
        })
        .catch(error => {
          console.error("FIREBASE sign-in error", error)
          // Handle Errors here.
          var errorCode = error.code
          var errorMessage = error.message
          // The email of the user's account used.
          var email = error.email
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential
          // ...
          //console.log("UNRULR signing out...")
          app.ports.setIdToken.send(null)
        })
    } else {
      //console.log("FIREBASE already signed-in")
      authorizeFirebaseUser(firebaseUser)
    }
  })
}

firebase.auth().onAuthStateChanged(user => {
  //console.log("FIREBASE auth state changed", user)
  if (user) {
    // User is signed in.
    // should already be handled...
    // authorizeFirebaseUser(user)
  } else {
    //console.log("UNRULR signing out...")
    app.ports.setIdToken.send(null)
  }
})

//const provider = new firebase.auth.GoogleAuthProvider();
app.ports.googleSignIn.subscribe(_data => {
  gapi.auth2
    .getAuthInstance()
    .signIn({
      scope: "profile email"
    })
    .then(onSignIn, err => {
      console.error("GOOGLE SIGN-IN error", err)
    })
})

app.ports.googleClassroomGrantScopes.subscribe(_req => {
  const googleUser = gapi.auth2.getAuthInstance().currentUser.get()
  //console.log("google user auth", googleUser.getAuthResponse(true))
  //console.log("google user get", googleUser)

  const classroomScopes = [
    "https://www.googleapis.com/auth/classroom.courses.readonly"
  ]
  const options = new gapi.auth2.SigninOptionsBuilder({
    scope: classroomScopes.join(" ")
  })

  if (googleUser.hasGrantedScopes(classroomScopes)) {
    //console.log("already has scopes")
    app.ports.setGoogleAuthResponse.send(googleUser.getAuthResponse(true))
  } else {
    googleUser.grant(options).then(
      success => {
        //console.log("grant scopes success", success.getAuthResponse(true))
        app.ports.setGoogleAuthResponse.send(success.getAuthResponse(true))
      },
      err => {
        console.error("grant scopes error", err)
      }
    )
  }
})

app.ports.googleClassroomGrantOfflineAccess.subscribe(_req => {
  const googleUser = gapi.auth2.getAuthInstance().currentUser.get()

  const offlineClassroomScopes = [
    "https://www.googleapis.com/auth/classroom.courses.readonly",
    "https://www.googleapis.com/auth/classroom.rosters.readonly",
    "https://www.googleapis.com/auth/classroom.profile.emails",
    "https://www.googleapis.com/auth/classroom.profile.photos",
    "https://www.googleapis.com/auth/classroom.push-notifications"
  ]
  const options = {
    prompt: "consent",
    scope: offlineClassroomScopes.join(" ")
  }

  googleUser.grantOfflineAccess(options).then(
    success => {
      //console.log("grant scopes offline access success", success)
      app.ports.setGoogleAuthorizationCode.send(success.code)
    },
    err => {
      console.error("grant offline scopes error", err)
    }
  )
})

let players = {}
app.ports.playVideo.subscribe(videoId => {
  const element = document.getElementById(videoId)
  if (players[videoId] && element.tagName === 'VIDEO') {
    //console.log(`Player for video ${videoId} already exists but element is gone... disposing...`)
    players[videoId].dispose()
    players[videoId] = null
  }
  if (!players[videoId]) {
    const player = videojs(videoId, {}, function () {
      videojs.log(`Your player for video ${videoId} is ready!`)

      // In this context, `this` is the player that was created by Video.js.
      // this.play();

      // How about an event listener?
      this.on('ended', function() {
        videojs.log(`Video ${videoId} has ended`)
      })
    })
    players[videoId] = player
    console.log(`Created player for video ${videoId}`)
  }
})